/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';

export default StyleSheet.create({
  DocUploaderMobileModal: {
    position: 'relative',
    height: '100%',
    backgroundColor: colors.snow,
  },

  submitProgress: {
    height: 4,
    width: '100%',
    position: 'absolute',
    top: 0,
  },

  contentContainer: {
    ...mixins.paddingHorizontal(15),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    overflowY: 'scroll',
  },

  description: {
    ...mixins.marginVertical(20),
    color: colors.clayPlus4,
    textAlign: 'center',
  },

  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  title: {
    margin: 0,
    padding: 0,
    color: colors.clayPlus4,
    fontSize: 16,
    fontWeight: fonts.weight.semibold,
  },

  iconWrapper: {
    paddingRight: 10,
  },

  content: {
    width: '100%',
  },

  inset: {
    ...mixins.globalBorderStyle,
    backgroundColor: colors.white,
    padding: 20,
  },

  uploadList: {
    ...mixins.margin(10, 0, 0),
    padding: 0,
    listStyle: 'none',
  },

  uploadItem: {
    paddingTop: 10,

    ':not(:last-child)': {
      ...mixins.borderBottom(1, 'solid', colors.clayMinus2),
      paddingBottom: 10,
    },
  },

  controls: {
    width: '100%',
    marginTop: 30,
  },

  submitButton: mixins.marginVertical(10),
});
